// Dropdown

// Override Bootstrap dropdown with 'preventOverflow' option

watch('[data-bs-toggle*="dropdown"]', dropdown => new Dropdown(dropdown, {
    popperConfig: (config) => {
        const preventOverflow = config.modifiers.find(({name}) => name === 'preventOverflow');

        if (typeof preventOverflow != 'undefined') {
            preventOverflow.options = {
                ...preventOverflow.options,
                altAxis: true
            }
        }

        return config;
    }
}));
